import React from 'react';
import ReactModal from 'react-modal';
import styles from './index.css';
import bindAll from 'lodash.bindall';
import {defineMessages, FormattedMessage} from 'react-intl';
// import {requestRemoveAccount} from '../../lib/api/login.js';
import {toast} from 'react-hot-toast';
import PropTypes from 'prop-types';
const messages = defineMessages({
    title: {
        id: 'gui.accountCancelation.title',
        defaultMessage: 'Account Cancellation',
        description: 'Account Cancellation'
    },
    text: {
        id: 'gui.accountCancelation.text',
        defaultMessage:
            'Account cancellation is an unrecoverable operation. If needed, please confirm the account’s cancellation again.',
        description:
            'Account cancellation is an unrecoverable operation. If needed, please confirm the account’s cancellation again.'
    },
    continueDeleteAccount: {
        id: 'gui.accountCancelation.continueDeleteAccount',
        defaultMessage: 'Continue',
        description: 'Continue'
    },
    confirmDeleteMessage: {
        id: 'gui.accountCancelation.confirmDeleteMessage',
        defaultMessage: 'Request submitted. The account will be automatically canceled 30 days after submitting the request. During this period, the login account will automatically cancel the cancellation process.',
        description: 'Request submitted. The account will be automatically canceled 30 days after submitting the request. During this period, the login account will automatically cancel the cancellation process.'
    },
    errorMessage: {
        id: 'gui.accountCancelation.errorMessage',
        defaultMessage: 'Account cancellation failed, please try again later',
        description: 'Account cancellation failed, please try again later'
    }
});

class AccountCancelationModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            isShow: false,
            countDown: 5,
            isContinue: false,
            isConfirm: false
        };
        bindAll(this, [
            'handleShow',
            'handleHidden',
            'handleContinueDeleteAccount',
            'handleConfirm'
        ]);
    }

    handleShow () {
        this.setState({isShow: true,
            countDown: 5,
            isContinue: false,
            isConfirm: false});
    }

    handleHidden () {
        this.setState({isShow: false});
    }

    // 继续注销此账号
    handleContinueDeleteAccount () {
        this.setState({isContinue: true});
        this.timer = setInterval(() => {
            this.setState({countDown: this.state.countDown - 1});
            if (this.state.countDown === 0) {
                clearInterval(this.timer);
            }
        }, 1000);
    }

    // 确认注销账号
    handleConfirm () {
        // this.props.onLoadingStarted();
        // new Promise((resolve, reject) => {
        //     requestRemoveAccount(resolve, reject);
        // })
        //     .then(() => {
        //         this.props.onUserLoggedOut();
        //     })
        //     .catch(err => {
        //         toast.error(<FormattedMessage
        //             {...messages.errorMessage}
        //         />);
        //     })
        //     .finally(() => {
        //         this.setState({
        //             isConfirm: true,
        //             isContinue: false
        //         });
        //         this.props.onLoadingFinished();
        //     });
    }

    render () {
        return (
            <ReactModal
                id="Account Cancellation"
                isOpen={this.state.isShow}
                className={styles.modalContent}
                overlayClassName={styles.modalOverlay}
            >
                <div className={styles.modalBody}>
                    <div className={styles.modalTitle}>
                        <FormattedMessage {...messages.title} />
                    </div>

                    <div className={styles.modalBodyText}>
                        <p>
                           
                            {this.state.isConfirm ? <FormattedMessage {...messages.confirmDeleteMessage} /> : <FormattedMessage {...messages.text} />}
                        </p>
                    </div>
                    <div className={styles.buttonGroup}>

                        {this.state.isConfirm ? <button
                            className={styles.confirmButton}
                            onClick={this.handleHidden}
                        ><FormattedMessage id="gui.prompt.ok" /></button> : (
                            <>
                                {/* 第一次点击 */}
                                {!this.state.isContinue && (
                                    <button
                                        onClick={this.handleContinueDeleteAccount}
                                        className={styles.confirmButton}
                                    >
                                        <FormattedMessage
                                            {...messages.continueDeleteAccount}
                                        />
                                    </button>
                                )}
                                { this.state.isContinue && (
                                    <button
                                        onClick={this.handleConfirm}
                                        className={styles.confirmButton}
                                        style={
                                            this.state.countDown > 0 ?
                                                {
                                                    backgroundColor:
                                                  'hsla(30, 81%, 94%, 1)'
                                                } :
                                                {
                                                    backgroundColor:
                                                  'hsla(29, 85%, 59%, 1)'
                                                }
                                        }
                                        disabled={this.state.countDown > 0}
                                    >
                                        <FormattedMessage id="gui.prompt.ok" />{' '}
                                        {this.state.countDown > 0 ?
                                            `(${this.state.countDown})` :
                                            ''}
                                    </button>
                                )}
                                <button
                                    className={styles.cancelButton}
                                    onClick={this.handleHidden}
                                >
                                    <FormattedMessage id="gui.prompt.cancel" />
                                </button>
                            </>
                        )}

                    </div>
                </div>
            </ReactModal>
        );
    }
}

AccountCancelationModal.propTypes = {
    onUserLoggedOut: PropTypes.func,
    onLoadingStarted: PropTypes.func,
    onLoadingFinished: PropTypes.func
};


export default AccountCancelationModal;
